import { FC, useState, createContext } from 'react';
type SidebarContext = {
  sidebarToggle: any;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  hidesidebar:any;
  hidesdebarformobile:()=> void

};

export const SidebarContext = createContext<SidebarContext>(
  {} as SidebarContext
);

export const SidebarProvider: FC = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [hidesidebar,sethidesidebar] = useState(false)
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const hidesdebarformobile = () => {
    sethidesidebar(!hidesidebar)
  }

  
  const closeSidebar = () => {
    
  };

  return (
    <SidebarContext.Provider
      value={{ sidebarToggle, toggleSidebar, closeSidebar,hidesidebar ,hidesdebarformobile}}
    >
      {children}
    </SidebarContext.Provider>
    
  );
};
